// extracted by mini-css-extract-plugin
module.exports = {"superTable":"_7tFwkCHfjvxaRr56W5E5vg==","tableContainer":"WU0KOQurictdnN-iZUIlwg=="};